import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { CurrencyExchangeRateItem } from './CurrencyExchangeRateItem'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { GetAccountCurrencyExchangeRatesByAccountIdAndAccountCurrencyIdAsync, resetSelectedRecordObjectInState,DeleteSelectedAccountCurrencyExchangeRateAsync,updatePagination } from './CurrencyExchangeRateSlice'
import { useLocation } from 'react-router-dom';
import { CurrencyExchangeRateForm } from './CurrencyExchangeRateForm';
import fetchAPI from '../../../common/fetchAPI';
import { getAccountBaseCurrencyIdAsync } from '../currencies/CurrenciesSlice';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import ExchangeRateOffCanvas from '../../../common/OffCanvas';
import { useTranslation } from 'react-i18next';
import CustomPagination from "../../../common/Pagination";
import Select, { StylesConfig } from 'react-select';
import { updatePageIdState, getPagePermissionsAsync,getParentPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList,sortData, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';


const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

export const CurrencyExchangeRate = () => {

    const dispatch = useAppDispatch();
    const { CurrencyId } = useAppSelector((state) => state.currencies);
    const { CurrencyExchangeRateList, isReload, selectedRecord,isLoading,sortOrder, sortColumn, search, pageNo, pageSize } = useAppSelector((state) => state.currencyExchangeRate);
    

    const location = useLocation();
    const { obj, CurrencyName } = location.state || {};
    const params = new URLSearchParams(location.search);
    // const AccountCurrencyId = params.get('AccountCurrencyId');
    const [BaseCurrency, SetBaseCurrency] = useState<any | ''>([]);
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const { t } = useTranslation();
    const {  menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const parentPageId: string = '104';
    const pageId: string = '105';
    let AccountCurrencyId = 0;
    if (CurrencyId && CurrencyId !== 0) {
        AccountCurrencyId = CurrencyId;
     } else if (obj && obj.AccountCurrencyId) {
        AccountCurrencyId = obj.AccountCurrencyId;
    }
    
    
    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            }
        };
        const fetchParentPagePermissions = async () => {
            if (parentPageId && parentPageId !== '') {
                const res = await dispatch(getParentPagePermissionsAsync(parentPageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
                else {
                    fetchPagePermissions();
                }
            }
        };
        fetchParentPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);


    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };
    
    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1); 
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };
    
    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

//    const filteredData = CurrencyExchangeRateList.filter((item: any) => {
//     const searchTermLowerCase = searchTerm.toLowerCase();
//     return Object.values(item).some((value: any) => {
//         if (typeof value === 'string') {
//             return value.toLowerCase().includes(searchTermLowerCase);
//         }  else if (typeof value === 'number') {
//                 return value.toString().includes(searchTermLowerCase);
//             }
//         return false;
//     });
// });

    //const filteredData = getFilteredList(CurrencyExchangeRateList,searchTerm)
    // const filteredData = CurrencyExchangeRateList.filter((item: any) => {
    //     const searchTermLowerCase = searchTerm.toLowerCase();
    //     return Object.values(item).some((value: any) => {
    //         if (typeof value === 'string') {
    //             // Check if value is a date string
    //             if (value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/)) {
    //                 // Convert date string to Date object
    //                 const dateValue = new Date(value);
    //                 // Check if date is valid
    //                 if (!isNaN(dateValue.getTime())) {
    //                     // Format date as needed for comparison
    //                     const formattedDate = dateValue.toLocaleDateString('en-US', {
    //                         year: 'numeric',
    //                         month: 'numeric', // Use 'numeric' for 1-digit month
    //                         day: 'numeric', // Use 'numeric' for 1-digit day
    //                         // year: 'numeric',
    //                         // month: '2-digit',
    //                         // day: '2-digit',
    //                     });
    //                     return formattedDate.toLowerCase().includes(searchTermLowerCase);
    //                 }
    //             } else {
    //                 // Preprocess the search term for date values without leading zeros
    //                 const processedSearchTerm = value.toLowerCase().replace(/\b(\d{1})\/(\d{1,2})\/(\d{4})\b/g, '0$1/$2/$3');
    //                 return processedSearchTerm.includes(searchTermLowerCase);
    //             }
    //         } else if (typeof value === 'number') {
    //             return value.toString().includes(searchTermLowerCase);
    //         }
    //         return false;
    //     });
    // });

    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = CurrencyExchangeRateList.length;
    // const recordsFiltered = filteredData.length;

    const filteredData: any = getFilteredList(CurrencyExchangeRateList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = CurrencyExchangeRateList.length;
    const recordsFiltered = filteredData.length;

    useEffect(() => {
        if (isReload) {
            dispatch(GetAccountCurrencyExchangeRatesByAccountIdAndAccountCurrencyIdAsync(AccountCurrencyId));
        }
    }, [isReload]
    )

    useEffect(() => {
        dispatch(GetAccountCurrencyExchangeRatesByAccountIdAndAccountCurrencyIdAsync(AccountCurrencyId));
        GetCurrentBaseCurrenyAsync();
    }, [dispatch])

    

    const GetCurrentBaseCurrenyAsync = async () => {
        const response = await fetchAPI("api/v2/CurrencyExchangeRates/GetCurrentBaseCurreny", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        SetBaseCurrency(json.Data);
    }

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(DeleteSelectedAccountCurrencyExchangeRateAsync(CurrencyExchangeRateList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            if(originalPromiseResult[0] !== undefined)
                            {
                                originalPromiseResult[0].StatusCode === "200" ?
                                    ShowToast("Currency Exchange Rates Delete Successfully", 'Success', "success", "toast-top-right") :
                                    ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                            }
                            else
                            {
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            }
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });

    }
    
    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        setIsModalOpen(true);
    }
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
               {isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <div className="d-flex">
                    <h3 className="card-title fw-bold mainHeading"  >
                        {/* {t('Exchange Rate')} */}
                        {getValueFromResource('Exchange Rate',dispatch, t)}
                        </h3>
                     <span className="card-title text-gray-400 text-muted me-2 fs-6"> - {CurrencyName}</span>
                    </div>
                    <div className="card-toolbar align-items-center">
                        {/* <div className="d-flex align-items-center flex-wrap">
                            <div
                                data-tooltip-id="tooltip-Description"
                                data-tooltip-content=
                                // {t("Current Base Curency")}
                                {getValueFromResource('Current Base Currency',dispatch, t)}
                                data-tooltip-place="bottom"
                            >
                                <span className='badge badge-light-success fs-7 fw-semibold'> {BaseCurrency.length > 0 && BaseCurrency[0].BaseCurrency}</span>
                            </div>
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div> */}
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                        {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                          /> */}
                                                           <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div> */}
                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                    />
                                </div>
                            </>
                        )}

                        {(IsAdd || (IsDelete && CurrencyExchangeRateList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ):null
                        }
                        
                        {IsAdd &&
                            <button 
                                type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}
                                style={{ marginRight: '2px', display: CurrencyExchangeRateList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                {/* {t('Add Exchange Rate')} */}
                                {getValueFromResource('Add Exchange Rate',dispatch, t)}

                            </button>
                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: CurrencyExchangeRateList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{CurrencyExchangeRateList.filter((item: any) => item.isSelected === 1).length}</span>
                                     {/* {t('Selected')} */}
                                     {getValueFromResource('Selected',dispatch, t)}

                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: CurrencyExchangeRateList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete',dispatch, t)}

                                </button>
                            </>
                        }
                    </div>
                </div>
                {/* <div className="card-body"> */}
                <div className="card-Report-body">
                    <div className="table-responsive">
                        <CurrencyExchangeRateItem CurrencyExchangeRateList={currentItems} t={t} onopenModal={openModal} IsEdit={IsEdit} IsDelete={IsDelete} />
                    </div>
                </div>
            </div>
            {isModalOpen &&
                <CurrencyExchangeRateForm AccountCurrencyId={AccountCurrencyId} t={t} oncloseModal={closeModal} />
            }
        </>
    )
}
